import React from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';
import { useMerchantPath } from '@domain/merchants/hooks/useMerchantPath';
import Link from 'next/link';

interface GoToEditAccountButtonProps {
  isEdit?: boolean;
}

export const GoToEditAccountButton = (props: ButtonProps & GoToEditAccountButtonProps) => {
  const path = useMerchantPath();

  return (
    <Link href={`${path}/account/${props.isEdit ? '' : 'edit'}`} passHref>
      <Button
        px={0}
        variant="tertiary"
        colorScheme="primary"
        color="primary.350"
        textDecor="underline"
        fontWeight="normal"
        size="md"
        height="30px"
      >
        {props.isEdit ? 'Cancel' : 'Edit'}
      </Button>
    </Link>
  );
};
